module.exports = __webpack_public_path__ + "img/azure.f64efe04.svg";